<template>
  <main
    class="basket-page"
    data-fullscreen
    v-background-color="$store.getters['ui/getBackgroundColor']"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
  >
    <MainHeader data-element="main-header" />
    <basket :hideAlcoholNotice="hideAlcoholNotice" />
  </main>
</template>

<script>
import Basket from "@/components/basket/Basket";
import menuAndBasket from "@/mixins/menuAndBasket";
import MainHeader from "@/components/ui/MainHeader";
import { mapGetters } from "vuex";
export default {
  components: {
    Basket,
    MainHeader,
  },
  mixins: [menuAndBasket],
  computed: {
    header() {
      return {
        text: "Back to menu",
        link: "/menus",
      };
    },
  },
  computed: {
    ...mapGetters({
      site: "getSite",
    }),
    hideAlcoholNotice() {
      return this.site && this.site.hideAlcoholNotice;
    },
  },
  methods: {
    async init() {
      this.$store.dispatch("checkNecessaryDataToProceed");
      this.$store.dispatch(`iOrderCore/setIorderConfigs`);
    },
  },
  created() {
    this.init();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/helpers.scss";

.basket-page {
  background-color: #fff;
  padding-bottom: 24px;
  width: 100%;
  * {
    @include noselect;
  }
}
</style>
